export default "__VITE_ASSET__D0zGraXl__"